import script from "./firstRecharge.vue?vue&type=script&setup=true&lang=ts"
export * from "./firstRecharge.vue?vue&type=script&setup=true&lang=ts"

import "./firstRecharge.vue?vue&type=style&index=0&id=7618444e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7618444e"]])

export default __exports__